module.exports = __webpack_public_path__ + "static/sec1-55419a16a1f8e706249790cc396e14e2.png";